// Mapa de ubicaciones (sites)

import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { apiFetchJson } from '../fetchWrapper';
import { formatDashedDate } from '../util/DateUtil';
import { populateSiteData, getSiteDataForSite, getIconByEnrichedSite, getAttendanceIcon, getGosenIcon } from '../util/MapUtil';
import { getAttendanceStatusLabel } from './AttendanceStatus';

// Fix default icon paths for Leaflet when using webpack/CRA
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default function SiteMap({
  clientId,
  defaultLat = 19.432608,
  defaultLng = -99.133209,
  zoom = 12,
  height = 400,
}) {

  const [loading, setLoading] = useState(false);
  const [sites, setSites] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [shiftTemplates, setShiftTemplates] = useState([]);

  const [attendances, setAttendances] = useState([]);
  const [siteData, setSiteData] = useState({});
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    setLoading(true);
    const url = clientId ? `/api/clients/${clientId}/sites` : `/api/sites`;
    apiFetchJson(url).then(setSites)
  }, [clientId]);

  useEffect(() => {
    const now = new Date();

    if (now.getHours() < 7) {
      now.setDate(now.getDate() - 1);
    }

    const dateStr = formatDashedDate(now);

    Promise.all([
      apiFetchJson(`/api/shift-templates`),
      apiFetchJson(`/api/attendances?startDate=${dateStr}`),
      apiFetchJson(`/api/scheduled-shifts?startDate=${dateStr}`),
      apiFetchJson(`/api/employees`)
    ]).then(([templates, attendances, shifts, employees]) => {
      setShiftTemplates(templates);
      setAttendances(attendances);
      setShifts(shifts);
      setEmployees(employees)
    });
  }, []);

  useEffect(() => {
    if (!sites.length || !shiftTemplates.length || !shifts.length) return;

    const data = populateSiteData(shiftTemplates, attendances, shifts, sites, employees);
    setSiteData(data);
  }, [sites, shiftTemplates, attendances, shifts]);

  return (
    <div style={{ width: '100%', height }}>
      <MapContainer center={[defaultLat, defaultLng]} zoom={zoom} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {sites.map((site) => {
          if (site.latitude == null || site.longitude == null) return null;

          const enrichedSite = getSiteDataForSite(site.id, siteData);
          return (
            <React.Fragment key={site.id}>
              <Marker
                position={[site.latitude, site.longitude]}
                icon={getIconByEnrichedSite(enrichedSite)}
              >
                <Tooltip>
                  {site.name} - {getAttendanceStatusLabel(enrichedSite?.status)}
                </Tooltip>

                <Popup>
                  <strong>{site.name}</strong>
                  <br />
                  {site.address.street}, {site.address.city}, {site.address.state}
                  <br />
                  Estado: {getAttendanceStatusLabel(enrichedSite?.status)}
                </Popup>
              </Marker>

              {enrichedSite?.attendance?.latitude != null &&
                enrichedSite?.attendance?.longitude != null && (
                  <Marker
                    key={`attendance-${site.id}`}
                    position={[
                      enrichedSite.attendance.latitude,
                      enrichedSite.attendance.longitude
                    ]}
                    icon={getAttendanceIcon(enrichedSite.attendance)}
                  >
                    <Tooltip>
                      {`${enrichedSite.employee.user.person.lastnameFirst} ${enrichedSite.employee.user.person.firstname} - ${site.name}`}
                    </Tooltip>
                  </Marker>
                )}
              {/* {site.id == 1 && (
                <Marker
                  key={`gosen-${site.id}`}
                  position={[
                    site.latitude,
                    site.longitude
                  ]}
                  icon={getGosenIcon()}
                >
                  <Tooltip>
                    Gosen
                  </Tooltip>
                </Marker>
              )} */}
            </React.Fragment>
          );
        })}
      </MapContainer>
    </div>
  );
}
